<template>
    <div :class="{ 'has-change-button': invertable }">
        <div class="is-multi w-100">
            <div class="is-multi__left">
                <select2 required
                    :name="prefix+'origin'"
                    v-model="originValue"
                    :options="originOptions"
                    className="form-control"
                    icon="boat"
                    placeholder="From"
                ></select2>
            </div>

            <div class="is-multi__right">
                <select2 required
                    :name="prefix+'destination'"
                    v-model="destinationValue"
                    :options="destinationOptions"
                    className="form-control"
                    placeholder="To">
                </select2>
            </div>
        </div>

        <button @click="handleInvert" class="is-change-button is-rounded" type="button" v-if="invertable">
            <span class="icon-compare-arrows"></span>
        </button>
    </div>

</template>

<script>
import Select2 from './Select2.vue'
import { mapState, mapGetters } from 'vuex'

export default {
    components: {
        Select2,
    },
    props: {
        invertable: {
            type: Boolean,
            default: true,
        },
        origin: String,
        destination: String,
        allowedOrigins: {
            type: Array,
            default() {
                return []
            }
        },
        prefix: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            originOptions: [],
            destinationOptions: [],
        }
    },
    mounted() {
        this.setOriginOptions()
        this.setDestinationOptions()
    },
    watch: {
        origin() {
            this.setDestinationOptions()
        },
        allowedOrigins() {
            this.setOriginOptions()
        },
        originOptions() {
            this.setDestinationOptions()
        }
    },
    computed: {
        originValue: {
            get() {
                return this.origin
            },
            set(value) {
                this.$emit('update:origin', value)
            }
        },
        destinationValue: {
            get() {
                return this.destination
            },
            set(value) {
                this.$emit('update:destination', value)
            }
        },
        ...mapState([
            'ports'
        ]),
        ...mapGetters([
            'getPortById'
        ])
    },
    methods: {
        async setOriginOptions() {
            let origin = this.originValue
            this.originOptions = this.getPortOptions(this.allowedOrigins)
            await this.$nextTick()
            if (this.originOptions.length == 1) {
                this.originValue = this.originOptions[0].id.toString()
            } else {
                this.originValue = origin
            }
        },
        async setDestinationOptions() {
            let destination = this.destinationValue

            let allowed = []
            if (this.origin) {
                allowed = this.getPortById(this.origin).destinations
            }
            else if (this.allowedOrigins && this.allowedOrigins.length) {
                let destinations = []
                this.ports.filter(port => this.allowedOrigins.includes(port.id)).forEach(port => {
                    destinations = destinations.concat(port.destinations)
                })
                allowed = destinations
            }
            else {
                allowed = this.ports.map(port => port.id)
            }
            allowed = allowed.map(port => parseInt(port))

            this.destinationOptions = this.getPortOptions(allowed)
            await this.$nextTick()
            if (this.destinationOptions.length == 1) {
                this.destinationValue = this.destinationOptions[0].id.toString()
            } else {
                this.destinationValue = destination                
            }
        },
        getPortOptions(allowed) {
            let ports = (allowed && allowed.length) ? this.ports.filter(port => allowed.includes(port.id)) : this.ports

            return ports.map(port => {
                return {
                    id: port.id,
                    text: port.name,
                }
            })
        },
        invert() {
            let origin = this.origin
            let destination = this.destination

            this.originValue = destination
            this.destinationValue = origin
        },
        handleInvert() {
            this.invert()
            this.$emit('inverted')
        }
    }
}
</script>